import React from 'react'

function FooterCon({ title, children }) {
    return (
        <div className='w-full'>
            {/* title */}
            <h3 className='font-medium text-lg'>{title}</h3>
            {/* Content */}
            <div className="w-full mt-4">
                {children}
            </div>
        </div>
    )
}

export default FooterCon